module.exports = __webpack_public_path__ + "static/media/Tammy_Fisher_Rec.8983d1ed.png";